<template>
  <div>
    <div class="vx-row">
      <vx-card>
        <vs-table
          :max-items="descriptionItems[0]"
          @selected="handleSelected"
          pagination
          :data="searches"
          description
          search
          :description-items="descriptionItems"
          description-title="Registries"
          description-connector="of"
          description-body="Pages"
        >
          <template slot="header">
            <div class="mr-2 mb-1 order-1">
              <vs-button
                icon-pack="feather"
                icon="icon-plus"
                @click="$router.push({ path:'/inventory' })"
                size="small"
                >{{ $t("inventory.label.Add_devices") }}</vs-button
              >
            </div>
          </template>
          <template slot="thead">
            <vs-th>{{ $t("inventory.label.EntityName") }}</vs-th>
            <vs-th>{{ $t("inventory.label.ItemDescription") }}</vs-th>
            <vs-th>{{ $t("inventory.label.ItemCode") }}</vs-th>
            <vs-th>{{ $t("inventory.label.AccountNumber") }}</vs-th>
            <vs-th>{{ $t("inventory.label.ChipId") }}</vs-th>
            <vs-th>{{ $t("inventory.label.IsPairing") }}</vs-th>
            <vs-th>{{ $t("inventory.label.PairedItemId") }}</vs-th>
            <vs-th>{{ $t("inventory.label.PairedItem") }}</vs-th>
            <vs-th>{{ $t("inventory.label.SerialNumber") }}</vs-th>
            <vs-th>{{ $t("inventory.label.WarrantyDate") }}</vs-th>
            <vs-th>{{ $t("inventory.label.ItemModel") }}</vs-th>
            <vs-th>{{ $t("inventory.label.status") }}</vs-th>
            <vs-th class="tHeadCenter">{{
              $t("inventory.label.actions")
            }}</vs-th>
          </template>
          <template slot-scope="{ data }">
            <vs-tr :key="index" :data="search" v-for="(search, index) in data">
              <vs-td :data="search.entityname">{{ search.entityname }}</vs-td>
              <vs-td :data="search.itemDescription">{{
                search.itemDescription
              }}</vs-td>
              <vs-td :data="search.itemCode">{{ search.itemCode }}</vs-td>
              <vs-td :data="search.accountNumber">{{
                search.accountNumber
              }}</vs-td>
              <vs-td :data="search.Chipid">{{ search.Chipid }}</vs-td>
              <vs-td :data="search.isPairing">{{ search.isPairing }}</vs-td>
              <vs-td :data="search.pairedItemId">{{
                search.pairedItemId
              }}</vs-td>
              <vs-td :data="search.pairedItemId">{{ search.PairedItem }}</vs-td>

              <vs-td :data="search.serialNumber">{{
                search.serialNumber
              }}</vs-td>
              <vs-td :data="getDate(search.warranty_date)">{{
                getDate(search.warranty_date)
              }}</vs-td>
              <vs-td :data="search.itemModel">{{ search.itemModel }}</vs-td>
              <vs-td :data="search.status">{{ search.status }}</vs-td>
              <vs-td :data="search" class="whitespace-no-wrap">
                <div class="container_img">
                  <feather-icon
                    icon="EditIcon"
                    :title="$t('inventory.label.Edit')"
                    svgClasses="w-5 h-5 stroke-current cursor orange_icon"
                    @click.stop="editDataPopup(search)"
                    class="icon_row"
                  />
                  <feather-icon
                    icon="EditIcon"
                    :title="$t('inventory.label.ViewTraker')"
                    svgClasses="w-5 h-5 stroke-current cursor orange_icon"
                    @click.stop="viewTrakerPopup(search.serialNumber)"
                    class="icon_row"
                  />
                  <feather-icon
                    icon="TrashIcon"
                    :title="$t('inventory.label.Delete')"
                    svgClasses="w-5 h-5 text-danger stroke-current cursor"
                    @click.stop="
                      editJobsPopup = true;
                      delId = search.id;
                    "
                    class="icon_row"
                  />
                </div>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </vx-card>

      <!-- Edit View -->

      <div class="centerx">
        <vs-popup
          classContent="popup-example"
          :title="$t('inventory.label.EditQuality')"
          :active.sync="updateCraditPopup"
          class="popup-close"
        >
          <form>
            <div class="vx-row md:w-full lg:w-full sm:w-full mb-6">
              <div class="vx-col sm:w-full w-full">
                <small class="date-label font-semibold">{{
                  $t("inventory.label.Quality")
                }}</small>
                <v-select
                  label="mCodeValue"
                  v-model="detail.quality"
                  :reduce="(obj) => obj.mCodeValue"
                  :options="details.qualityDatas"
                  :placeholder="$t('inventory.label.SelectItem')"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  class="min-w-200 w-full mb-2 font-semibold"
                >
                  <template v-slot:option="option">{{
                    option.mCodeValue
                  }}</template>
                </v-select>
                <vs-input
                  :label="$t('inventory.label.ProvisionSerialNumber')"
                  type="text"
                  class="w-full font-semibold"
                  v-model="detail.provisioningSerialNumber"
                />
                <vs-input
                  :label="$t('inventory.label.SerialNumber')"
                  type="text"
                  class="w-full font-semibold"
                  v-model="detail.serialNumber"
                />
              </div>
            </div>

            <div class="vx-row float-right my-2">
              <span class="ml-1 mr-5">
                <vs-button type="border" @click="updateCraditPopup = false">{{
                  $t("inventory.label.Done")
                }}</vs-button>
              </span>
              <span class="ml-1 mr-2">
                <vs-button
                  icon-pack="feather"
                  icon="icon-check"
                  @click="saveQuality"
                  >{{ $t("inventory.label.Save") }}</vs-button
                >
              </span>
            </div>
          </form>
        </vs-popup>
      </div>

      <!-- View Tracker Popup -->

      <div class="centerx">
        <vs-popup
          classContent="popup-example"
          :title="$t('inventory.label.EditQuality')"
          :active.sync="updateCraditPopup1"
          class="popup-close"
        >
          <form>
            <vs-table :data="historys">
              <template slot="thead">
                <vs-th>{{ $t("inventory.label.RefType") }}</vs-th>
                <vs-th>{{ $t("inventory.label.TransactionDate") }}</vs-th>
                <vs-th>{{ $t("inventory.label.Movement") }}</vs-th>
                <vs-th>{{ $t("inventory.label.FromOffice") }}</vs-th>
                <vs-th>{{ $t("inventory.label.ToOffice") }}</vs-th>
              </template>
              <template slot-scope="{ data }">
                <vs-tr
                  :key="index"
                  :data="history"
                  v-for="(history, index) in data"
                >
                  <vs-td :data="history.refType">{{ history.refType }}</vs-td>
                  <vs-td :data="history.transactionDate">{{
                    history.transactionDate
                  }}</vs-td>
                  <vs-td :data="history.movement">{{ history.movement }}</vs-td>
                  <vs-td :data="history.fromOffice">{{
                    history.fromOffice
                  }}</vs-td>
                  <vs-td :data="history.toOffice">{{ history.toOffice }}</vs-td>
                </vs-tr>
              </template>
            </vs-table>

            <div class="vx-row float-right my-2">
              <span class="ml-1 mr-5">
                <vs-button type="border" @click="updateCraditPopup1 = false">{{
                  $t("inventory.label.Done")
                }}</vs-button>
              </span>
            </div>
          </form>
        </vs-popup>
      </div>
      <div class="centerx">
        <vs-popup
          classContent="popup-example"
          :title="$t('inventory.label.DeleteItemDetail')"
          :active.sync="editJobsPopup"
          class="popup-close"
        >
          <div class="vx-row md:w-full lg:w-full sm:w-full mb-6">
            <div class="vx-col sm:w-full w-full">
              <div class="vx-col sm:w-full w-full">{{$t("inventory.label.Are_you_sure_?")}}</div>
            </div>
          </div>
          <div class="vx-row">
            <span class="ml-4 mr-1">
              <vs-button type="border" @click="editJobsPopup = false">{{
                $t("inventorylabel.Cancel")
              }}</vs-button>
            </span>
            <span class="ml-1 mr-2">
              <vs-button @click="deleteTeam(delId)" color="warning">{{
                $t("inventory.label.Ok")
              }}</vs-button>
            </span>
          </div>
        </vs-popup>
      </div>
    </div>
  </div>
</template>
<script>
import {
  getByItemDetailsdropdown,
  getSqlSearch,
  getByItemDetailsTemplate,
  getMrnHistory,
  saveQuality,
  deleteItemDetail,
} from "@/http/inventory";
import moment from "moment";
import vSelect from "vue-select";
import _ from "lodash";
import { mapState } from "vuex";

export default {
  data() {
    return {
      edititemId: "",
      editJobsPopup: false,
      addPopup: false,
      searchOption: 0,
      purchaseDate: "",
      editOrderQty: 0,
      saveGrnPayload: {
        purchaseDate: "",
        orderdQuantity: "",
        locale: "en",
        dateFormat: "dd MMMM yyyy",
        purchaseNo: "",
        supplierId: "",
        officeId: "",
        itemMasterId: "",
      },
      descriptionItems: [5, 10, 15],
      items: [],
      item: {},
      searches: [],
      updateCraditPopup: false,
      updateCraditPopup1: false,
      historys: {
        fromOffice: "",
        itemDescription: "",
      },
      history: [],
      details: {},
      detail: {
        quality: "",
        serialNumber: "",
        provisioningSerialNumber: "",
      },
      qualityDatas: [],
      itemId: "",
      delId: 0,
    };
  },
  components: {
    "v-select": vSelect,
  },

  computed: {
    ...mapState({
      formattedDate: (state) => state.settings.selectedDateFormat,
    }),
  },
  // mounted() {
  //   this.getGoodsList();
  //   this.editGrnTemplate();
  // },
  methods: {
    handleSelected(detail) {
      this.$router.push({
        name: "View Item Details",
        params: { id: detail.id },
      });
    },
    editData(id) {
      this.$router.push({ name: "Edit Good", params: { id: id } });
    },
    async editDataPopup(search) {
      const response = await getByItemDetailsTemplate();
      this.details = response.data;
      this.detail.serialNumber = search.serialNumber;
      this.detail.provisioningSerialNumber = search.serialNumber;
      this.detail.quality = search.quality;
      this.itemId = search.id;
      this.updateCraditPopup = true;
    },
    async viewTrakerPopup(id) {
      const history = await getMrnHistory(id);
      this.historys = history.data.pageItems;
      this.updateCraditPopup1 = true;
    },
    async deleteTeam(id) {
      try {
        await deleteItemDetail(id);
        this.getByItemDetailsTemplate();
        this.editJobsPopup = true;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },

    getDate(date) {
      return moment(date).format(this.formattedDate);
    },
    async getByItemDetailsdropdown() {
      try {
        const item = await getByItemDetailsdropdown();
        this.items = item.data;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },

    async getSqlSearch() {
      try {
        const search = await getSqlSearch();
        this.searches = search.data.pageItems;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async getByItemDetailsTemplate() {
      try {
        const response = await getByItemDetailsTemplate();
        this.details = response.data;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async saveQuality() {
      const postItemObj = {
        quality: this.detail.quality,
        serialNumber: this.detail.serialNumber,
        provisioningSerialNumber: this.detail.provisioningSerialNumber,
      };
      try {
        const resp = await saveQuality(this.itemId, postItemObj);
        if (resp.data.resourceId) {
          this.updateCraditPopup = false;
          this.$router.push({
            name: "View Item Details",
            params: { id: this.itemId },
          });
        }
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    editGrn(grn1) {
      this.grn = grn1;
      this.editOrderQty = this.grn.orderdQuantity;
    },
  },
  created() {
    this.id = this.$route.params.id;
    this.getByItemDetailsdropdown();
    this.getSqlSearch();
    this.getByItemDetailsTemplate();
    this.getMrnHistory();
  },
  watch: {
    editGrnPopup(newValue) {
      if (newValue) {
        this.getByItemDetailsdropdown();
      }
    },
  },
};
</script>
